import { SGWorkflowConfig } from '../config';
import { MessageApiFactory } from '../../../projects/workspaces-api-axios';
import store from './store';
import { alertUtils } from './actions-alerts';
import { getErrorMessage } from '../utility/utility';

export const countMessages = async (
  {
    sgWorkflowConfig,
    accessToken,
  }: {
    sgWorkflowConfig: SGWorkflowConfig;
    accessToken?: string;
  },
  processInstanceId: string,
  engineId: string
) => {
  let count = 0;
  if (accessToken && processInstanceId && engineId) {
    try {
      const messageApi = MessageApiFactory({ accessToken: accessToken }, sgWorkflowConfig.workspaceApiBasePath);
      const response = await messageApi.countMessages(processInstanceId, engineId, {
        headers: { Authorization: accessToken },
      });

      if (response !== undefined && response.data !== undefined && response.data.count !== undefined) {
        count = response.data.count;
      }
    } catch (err) {
      alertUtils.publishAlertDanger('Error', getErrorMessage(err.response && err.response.data));
    }
  }

  // Update the message count
  store.setState({
    messageCount: count,
  });
};
